import { api } from "./api";

export const customFunctionValidateApi = (params) => {
  return api.post(`/custom-report/function/validate`, JSON.stringify(params));
};

export const customFunctionSaveApi = (params) => {
  return api.post(`/custom-report/function/save`, JSON.stringify(params));
};

export const customFunctionListApi = () => {
  return api.get(`/custom-report/function/list`);
};

export const customFunctionGetApi = (functionId) => {
  return api.get(`/custom-report/function/get/${functionId}`);
};

export const customFunctionUpdateApi = (params) => {
  return api.post(`/custom-report/function/update`, JSON.stringify(params));
};

export const customFunctionDeleteApi = (params) => {
  return api.post(`/custom-report/function/delete`, JSON.stringify(params));
};
